<template>
  <v-col>
    <v-tabs show-arrows v-model="tabs" centered :click="$emit('change',this.eventChange())">
      <v-tab v-for="(item,i) in dayList" :key="i+item.name">
        <v-card-text tile text-center>
          <v-card-title>{{ item.name }}</v-card-title>
          <v-card-subtitle>{{ item.date }}</v-card-subtitle>
        </v-card-text>
      </v-tab>
    </v-tabs>
  </v-col>
</template>
 
<script>
import moment from "moment";

// const addPeriod = (date, period = 'days' ,days = 1, format = 'DD/MM/YYYY') => moment(date, 'DD/MM/YYYY', 'pt-BR').add(days, period).format(format);
// const subPeriod = (date, period = 'days' ,days = 1, format = 'DD/MM/YYYY') => moment(date, 'DD/MM/YYYY', 'pt-BR').subtract(days, period).format(format);

export default {
  props: {
    selectDay: {
      // type: String
    },
    selectDate: {
      // type: String
    },
    startDate: {
      // type: String,
      //default: new Date()
    },
    endDate: {
      // type: String,
      //default: new Date()
    },
  },
  data() {
    return {
      selectedDay: 0,
      tabs: null,
      filterType: 2,
      selectName: "",
      initDate: null,
      finalDate: null,
      filters: {
        sunday: {
          id: 0,
          name: "DOM",
          date: null,
          completeDate: null,
          active: true,
        },
        monday: {
          id: 1,
          name: "SEG",
          date: null,
          completeDate: null,
          active: false,
        },
        tuesday: {
          id: 2,
          name: "TER",
          date: null,
          completeDate: null,
          active: false,
        },
        wednesday: {
          id: 3,
          name: "QUA",
          date: null,
          completeDate: null,
          active: false,
        },
        thursday: {
          id: 4,
          name: "QUI",
          date: null,
          completeDate: null,
          active: false,
        },
        friday: {
          id: 5,
          name: "SEX",
          date: null,
          completeDate: null,
          active: false,
        },
        saturday: {
          id: 6,
          name: "SÁB",
          date: null,
          completeDate: null,
          active: false,
        },
      },
    };
  },
  created() {
    this.initWeek();
    this.initDay();
  },
  methods: {
    eventChange() {
      for (let variable in this.filters) {
        if (this.filters[variable].id === this.tabs) {
          return this.filters[variable];
        }
      }
    },
    initWeek() {
      for (let variable in this.filters) {
        if (this.filters[variable].id === this.tabs) {
          return this.filters[variable];
        }
      }
    },
    initDay() {
      moment.locale("pt-br");
      for (let variable in this.filters) {
        if (this.filters[variable].id === moment().day()) {
          this.setFilterByDate(
            this.filters[variable].id,
            this.filters[variable].date,
            this.filters[variable].completeDate
          );
        }
      }
    },
    // setActive(filter) {
    // return (this.filters[filter].active)? true : false
    // },
    setFilterByDate(id, date, completeDate) {
      let i = 0;
      for (let variable in this.filters) {
        // this.filters[variable].active =
        //   this.filters[variable].id === id ? true : false;
        if (!date && !completeDate && this.filters[variable].id === id) {
          date = this.filters[variable].date;
          completeDate = this.filters[variable].completeDate;
        }
        if (this.filters[variable].active) this.tabs = i;
        i++;
      }
    },
  },
  computed: {
    dayList() {
      let start;
      start = this.startDate ? this.startDate : new moment();
      let i = 0;
      let filters = this.filters;
      for (let variable in filters) {
        filters[variable].completeDate = moment(start).add(i, "days").toJSON();

        filters[variable].name = moment(start).add(i, "days").format("ddd");

        filters[variable].date = moment(
          moment(start, "DD/MM/YYYY", "pt-BR").add(i, "days"),
          "DD/MM/YYYY",
          "pt-BR"
        ).format("DD/MM");
        i += 1;
      }

      return filters;
    },
  },
};
</script>
